import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chisiamo-cosafacciamo',
  templateUrl: './chisiamo-cosafacciamo.component.html',
  styleUrls: ['./chisiamo-cosafacciamo.component.scss']
})
export class ChisiamoCosafacciamoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/chisiamo-cosafacciamo/chisiamo-cosafacciamo.component.ts